<script setup>
import SurveyCard from '@/components/calendar/drawer/pages/cards/SurveyCard.vue';
import endingCharacter from '@manseImages/nangman-naming/img-ending-character.png';

const fullWidthMode = inject('fullWidthMode', false);
const halfCol = computed(() => (fullWidthMode ? undefined : 6));

defineProps({
  /** 'recommend' | 'analyze' — 다시보기 버튼 라벨 분기용 */
  type: { type: String, default: 'recommend' },
  ratingResult: { type: Number, default: 0 },
  ratingStatus: { type: Boolean, default: false },
});

const emit = defineEmits(['goToOverView', 'postRate']);

const goToCoverPage = () => emit('goToOverView');
const postRate = (rate) => emit('postRate', rate);
</script>

<template>
  <VRow no-gutters class="full-height">
    <!-- 좌측: 응원 메시지 -->
    <VCol cols="12" :md="halfCol" class="no-pad-col">
      <div class="naming-ending-wrap right">
        <div class="naming-ending-card">
          <img :src="endingCharacter" alt="" class="naming-ending-card__char" />
          <div class="naming-ending-card__msg">
            <div class="naming-ending-card__msg-default">
              <p>이름은 오래도록 불리고 기억되는 의미의 한 조각입니다.</p>
              <p>이름 안에 담긴 마음과 흐름이, 함께하는 시간 속에 따뜻하게 스며들기를 바랍니다.</p>
            </div>
            <div class="naming-ending-card__msg-accent">
              <p>오래도록 사랑받고 자연스럽게 어울리는 이름이 되기를 진심으로 응원합니다.</p>
            </div>
          </div>
        </div>
      </div>
    </VCol>

    <!-- 우측: 평가하기 + 다시보기 (낭만궁합 마지막 페이지 동일 패턴) -->
    <VCol cols="12" :md="halfCol" class="no-pad-col">
      <div class="naming-ending-wrap left naming-ending-wrap--survey">
        <SurveyCard
          style="width: 100%"
          :ratingResult="ratingResult"
          :ratingStatus="ratingStatus"
          @postRate="postRate"
        />
        <div class="naming-ending-replay">
          <button type="button" class="naming-ending-replay__btn" @click="goToCoverPage">
            <i class="naming-ending-replay__icon"></i>
            다시보기
          </button>
        </div>
      </div>
    </VCol>
  </VRow>
</template>

<style lang="scss" scoped>
$naming-accent: #5e47a5;
$naming-bg-soft: #f8f6ff;

.full-height {
  height: 100%;
}

.no-pad-col {
  padding: 0 !important;
}

.naming-ending-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 20px;
  background: #fff;
  box-sizing: border-box;

  &.right {
    border-right: 1px solid #ebebeb;
  }

  &.left {
    border-left: 1px solid #ebebeb;
  }
}

.naming-ending-card {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  padding: 40px 32px;
  border-radius: 12px;
  background: $naming-bg-soft;
  box-sizing: border-box;
}

.naming-ending-card__char {
  width: 140px;
  height: 140px;
  flex-shrink: 0;
  object-fit: contain;
}

.naming-ending-card__msg {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  border-radius: 8px;
  background: #fff;
}

.naming-ending-card__msg-default,
.naming-ending-card__msg-accent {
  display: flex;
  flex-direction: column;

  p {
    margin: 0;
    font-family: Pretendard;
    font-size: 15px;
    line-height: 24px;
  }
}

.naming-ending-card__msg-default {
  p {
    color: #333;
    font-weight: 400;
  }
}

.naming-ending-card__msg-accent {
  p {
    color: $naming-accent;
    font-weight: 700;
  }
}

/* 우측: 평가 + 다시보기 */
.naming-ending-wrap--survey {
  flex-direction: column;
  gap: 120px;
  padding: 40px 24px;
}

.naming-ending-replay {
  display: flex;
  justify-content: center;
  width: 100%;
}

.naming-ending-replay__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 160px;
  padding: 10px 20px;
  justify-content: center;
  border-radius: 6px;
  border: 1px solid #ebebeb;
  background: #fff;
  color: #333;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  cursor: pointer;
}

.naming-ending-replay__icon {
  display: block;
  width: 16px;
  height: 16px;
  background: url('@/assets/images_manse/icon_return.svg') no-repeat center center;
  background-size: contain;
}
</style>
